document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener("load", function () {
      const preloaderCheese = document.getElementById("preloader-cheese");
      if (preloaderCheese) {
        preloaderCheese.style.opacity = "0";
        setTimeout(() => {
          preloaderCheese.style.display = "none";
        }, 100);
      }
    });
  });